import React, { memo } from "react";
import { FormCustom } from "./Styled";

const Form = (props) => <FormCustom {...props}>{props.children}</FormCustom>;

export default memo(Form);
